<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 3.49984H2.91667M2.91667 3.49984H12.25M2.91667 3.49984L2.91667
      11.6665C2.91667 11.9759 3.03958 12.2727
      3.25838 12.4915C3.47717 12.7103 3.77391 12.8332
      4.08333 12.8332H9.91667C10.2261 12.8332 10.5228 12.7103 10.7416
      12.4915C10.9604 12.2727 11.0833 11.9759 11.0833
      11.6665V3.49984M4.66667 3.49984V2.33317C4.66667 2.02375 4.78958
      1.72701 5.00838 1.50821C5.22717 1.28942 5.52391
      1.1665 5.83333 1.1665H8.16667C8.47609 1.1665 8.77283 1.28942
      8.99162 1.50821C9.21042 1.72701 9.33333 2.02375
      9.33333 2.33317V3.49984M5.83333 6.4165V9.9165M8.16667 6.4165V9.9165"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>